import { Link } from 'react-router-dom'
import { useAuth } from '../lib/auth-context.js'
import { SidebarNavLink } from './SidebarNavLink.js'

type Props = {
  onNavigate?: (() => void) | undefined
}

export function AdminSidebar({ onNavigate }: Props) {
  const { session, signOut } = useAuth()

  return (
    <div className="flex h-full flex-col">
      <div className="shrink-0 border-b border-border p-4">
        <Link to="/admin" onClick={onNavigate} className="flex items-center gap-2.5">
          <span
            aria-hidden
            className="inline-flex w-8 h-8 shrink-0 items-center justify-center rounded-md bg-gradient-primary text-white text-xs font-bold shadow-sm"
          >
            T
          </span>
          <div>
            <p className="text-sm font-bold tracking-tight text-foreground">Terafile Bin</p>
            <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 border border-destructive/30 rounded-full text-destructive font-medium">
              ADMIN
            </span>
          </div>
        </Link>
      </div>

      <nav className="flex-1 px-2 py-3 space-y-0.5">
        <SidebarNavLink to="/admin" end {...(onNavigate ? { onNavigate } : {})}>
          ダッシュボード
        </SidebarNavLink>
        <SidebarNavLink to="/admin/tenants" {...(onNavigate ? { onNavigate } : {})}>
          テナント一覧
        </SidebarNavLink>
        <SidebarNavLink to="/admin/plan-upgrade-requests" {...(onNavigate ? { onNavigate } : {})}>
          プラン変更申請
        </SidebarNavLink>
      </nav>

      <div className="shrink-0 border-t border-border p-3 space-y-2">
        {session?.user.email && (
          <p className="text-xs text-muted-foreground truncate px-1">{session.user.email}</p>
        )}
        <button
          type="button"
          onClick={() => signOut()}
          className="w-full px-3 py-1.5 border border-border rounded-md text-xs font-medium hover:bg-accent transition-colors"
        >
          ログアウト
        </button>
      </div>
    </div>
  )
}
